import {useCallback, useEffect, useState} from "react";
import useChangeFieldHandler from "../hooks/useChangeFieldHandler";
import PropTypes from 'prop-types'
import FormFields from "./FormFields";

const Form = ({value, onChange, submitted, onValidate, fields, children}) => {
    const [validationErrors, setValidationErrors] = useState(new Set())

    const {onChangeField} = useChangeFieldHandler(value, onChange)

    useEffect(() => {
        if (onValidate != null)
            onValidate(validationErrors.size > 0)
    }, [onValidate, validationErrors])

    const handleValidation = useCallback((hasError, fieldName) => {
        setValidationErrors(prevState => getNewValidationErrors(hasError, fieldName, prevState))
    }, [])
    //
    const getNewValidationErrors = (hasError, fieldName, prevState) => {
        const newValue = prevState
        if (hasError) {
            newValue.add(fieldName)
        } else {
            newValue.delete(fieldName)
        }

        return new Set(newValue);
    }

    return (
        <FormFields
            value={value}
            onChange={onChangeField}
            onValidate={handleValidation}
            submitted={submitted}
            parentValue={value}
            fields={fields}
            children={children}
        />
    )
}

Form.propTypes = {
    value: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    submitted: PropTypes.bool.isRequired,
    onValidate: PropTypes.func.isRequired,
    fields: PropTypes.array
}
export default Form;